import React from 'react';

import sizeMe from 'react-sizeme';
import Quagga from 'quagga';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import Conditions from '../../../Molecules/Conditions'

const conditions = {
    // inputStream
    // decoder
    // locator

    selects: [
    ],
    radios: [
    ],
    switches: [
        "locate",
        "debug",
    ],
    texts: [
        "numOfWorkers",
        "frequency",
    ]
}
const ints = [
    "numOfWorkers",
    "frequency",
]
class Scanner extends React.Component {

    _onProcessed = (result) => {
        this.props.onProcessed(result)
    }

    _onDetected = (result) => {
        this.props.onDetected(result)
    }

    componentDidMount() {
        console.log("you scanner ", this.props);
        const { config, onFinishInitialize } = this.props
        Quagga.init(config, onFinishInitialize);
        Quagga.onProcessed(this._onProcessed);
        Quagga.onDetected(this._onDetected);
    }

    componentWillUnmount() {
        Quagga.offProcessed(this._onProcessed);
        Quagga.offDetected(this._onDetected);
    }

    render() {
        return (
            <div id="interactive" className="viewport" />
        );
    }

};

class PracticeQuagga extends React.Component {
    state = {
        scanning: false,
        results: {},
        config: {
            inputStream: {
                type: "LiveStream",
                constraints: {
                    width: 640,
                    height: 480,
                    facing: "environment" // or user
                }
            },
            locator: {
                halfSample: true,
                patchSize: "large", // x-small, small, medium, large, x-large
                debug: {
                    showCanvas: false,
                    showPatches: true,
                    showFoundPatches: true,
                    showSkeleton: true,
                    showLabels: true,
                    showPatchLabels: true,
                    showRemainingPatchLabels: true,
                    boxFromPatches: {
                        showTransformed: true,
                        showTransformedBox: true,
                        showBB: true
                    }
                }
            },
            frequency: 10,
            numOfWorkers: 8,
            decoder: {
                readers: ["ean_reader"],
                debug: {
                    drawBoundingBox: true,
                    showFrequency: true,
                    drawScanline: true,
                    showPattern: true
                },
                multiple: false
            },
            locate: true
        }
    }

    handleChangeCondition = (name, value) => {
        const { config } = this.state
        // if (ints.indexOf(name) > -1) {
        //     value = parseInt(value)
        // }
        console.log("you name", name);
        console.log("you value", value);
        this.setState({ config: { ...config, [name]: value } })
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
    }

    onClickStartStopButton = () => {
        if (this.state.scanning) {
            this.setState({
                scanning: false,
            });
        } else {
            this.setState({
                scanning: true,
                results: {}
            });
        }
    }

    onFinishInitialize = (err) => {
        if (err) {
            return console.log(err);
        }
        const drawingCanvas = Quagga.canvas.dom.overlay;
        drawingCanvas.style.display = 'none';
        Quagga.start();
    }

    onDetected = (result) => {
        console.log("you onDetected ", result);
        const results = Object.assign({}, this.state.results)

        const code = result.codeResult.code
        var beforeResult = results[code]
        if (beforeResult) {
            beforeResult = {
                count: beforeResult.count + 1,
                result: result
            }
        } else {
            beforeResult = {
                count: 1,
                result: result
            }
        }
        results[code] = beforeResult
        this.setState({ results: results });
    }

    onProcessed = (result) => {
        console.log("you onProcessed ", result);
        // this.onProcessed(result);
    }

    render() {
        const { width } = this.props.size
        const { scanning, results, config, output } = this.state

        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Conditions options={conditions} values={config} handleChangeCondition={this.handleChangeCondition} />
                </Grid>
                <Grid item xs={12}>
                    <Button
                        fullWidth
                        onClick={this.onClickStartStopButton}
                        variant="contained"
                        color="primary">
                        {
                            scanning ? 'Stop' : 'Start'
                        }
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    {
                        scanning ?
                            <Scanner
                                config={config}
                                onFinishInitialize={this.onFinishInitialize}
                                onDetected={this.onDetected}
                                onProcessed={this.onProcessed}
                            />
                            :
                            null
                    }
                </Grid>
                <Grid item xs={12}>
                    <ol className="results">
                        {
                            Object.keys(results).sort().map((key) => {
                                const resultData = results[key]
                                if (!resultData) {
                                    return null;
                                }
                                const { result, count } = resultData
                                return (
                                    <li>
                                        {`${result.codeResult.code}: ${result.codeResult.format}: ${count}`}
                                    </li>
                                );
                            })
                        }
                    </ol>
                </Grid>
            </Grid>
        );
    }
}
export default sizeMe({ monitorHeight: true })(PracticeQuagga);